import template from './scheduleMobile.html';
import controller from './scheduleMobile.controller';
import './scheduleMobile.scss';

let scheduleMobileComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default scheduleMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/scheduleMobile/scheduleMobile.component.js